<template>
    <v-card flat>
        <v-overlay :value="loadingCampaignData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title>{{ activeCampaign.name ? activeCampaign.name : activeCampaign.id }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                dark
                color="bal-red"
                @click="editUser"
                v-if="hasPermissionForAction(PermissionsConstants.CAMPAIGN, PermissionsConstants.EDIT)"
            >
                <v-icon>edit</v-icon>
                {{ t("Edit") }}
            </v-btn>
            <v-menu
                offset-y
                bottom
                left
                v-if="hasPermissionForAction(PermissionsConstants.CAMPAIGN, PermissionsConstants.DELETE)"
            >
                <template v-slot:activator="{ on }">
                    <v-btn color="bal-dark-gray" class="px-2 ml-2 mx-2" style="min-width: 0;" dark v-on="on">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="handleDeleteCampaignClick">
                        <v-list-item-title style="color: red">{{ t("Delete") }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ t("General") }}
            </v-tab>
            <v-tab-item>
                <general-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import GeneralTab from "./campaign-tab-items/general-tab";
import Store from "@/store";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "user-view",
    components: { GeneralTab },
    data() {
        return {
            tab: 0,
            tabs: ["General"]
        };
    },
    async mounted() {
        document.addEventListener("keydown", this.nextTab);
        await this.getCampaignData(this.$route.params.campaignId);
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    computed: {
        ...mapState("CampaignStore", ["activeCampaign", "loadingCampaignData"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.nextTab);
    },
    methods: {
        ...mapActions("CampaignStore", ["getCampaignData", "deleteCampaign"]),
        closeDrawer() {
            this.$router.push({ name: "campaign-list" });
        },
        editUser() {
            this.$router.push({
                name: "campaign-edit",
                params: { campaignId: this.$route.params.campaignId, tab: this.tabs[this.tab] }
            });
        },
        nextTab(e) {
            if (e.keyCode === 69 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.editUser();
            }
            if (e.key === "ArrowLeft") {
                if (this.tab > 0) {
                    this.tab -= 1;
                }
            } else if (e.key === "ArrowRight") {
                if (this.tab + 1 < this.tabs.length) {
                    this.tab += 1;
                }
            }
        },

        async handleDeleteCampaignClick() {
            if (confirm(this.t("Are you sure you want to delete this campaign?"))) {
                await this.deleteCampaign({
                    campaignId: this.activeCampaign.id
                });
            }
        }
    }
};
</script>

<style scoped></style>
